/*
 * Colour swatches on the sale collection cards.
 *
 * Clicking one shows that colour's photo and points the card at that variant, without
 * leaving the grid. One delegated listener covers every card, including any the infinite
 * scroll appends later.
 */
(() => {
  const CARD = '.product-card-wrapper';

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.pbazaadi-swatch');
    if (!swatch) return;

    const card = swatch.closest(CARD);
    if (!card) return;

    // The swatch sits inside the card; nothing above it should treat this as a card click.
    event.preventDefault();
    event.stopPropagation();

    const src = swatch.dataset.swatchSrc;
    const img = card.querySelector('.pbazaadi-card-img');
    if (img && src) {
      // srcset wins over src, so it has to be replaced too or the old photo stays put.
      if (swatch.dataset.swatchSrcset) {
        img.srcset = swatch.dataset.swatchSrcset;
      } else {
        img.removeAttribute('srcset');
      }
      img.src = src;
    }

    // Send the shopper to the colour they picked rather than the default variant.
    const url = swatch.dataset.swatchUrl;
    if (url) {
      card.querySelectorAll('[data-card-link]').forEach((link) => { link.href = url; });
      card.dataset.productUrl = url;
    }

    // Direct-checkout buttons (power bank cards) buy the picked colour.
    const variantId = swatch.dataset.swatchVariantId;
    if (variantId) {
      card.querySelectorAll('[data-buy-now]').forEach((link) => {
        link.href = link.href.replace(/\/cart\/\d+:/, `/cart/${variantId}:`);
      });
    }

    card.querySelectorAll('.pbazaadi-swatch').forEach((s) => s.classList.remove('is-active'));
    swatch.classList.add('is-active');
  });
})();
